import 'reflect-metadata';
import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import { resolveGalaxyAccess } from '@core/pages/oj/galaxy/components/home/galaxy-home.helpers';
import { UserService } from '@core/services/user.service';

/**
 * 银河争霸赛比赛首页访问守卫
 *
 * 规则：未登录 或 非履约用户 → 重定向 OJ 首页('/')，均不弹登录弹窗。
 * 履约字段来源：userService.user.exerciseId 不为空。
 */
export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.client) {
    const userService = useRootService(UserService);
    const isLogin = userService.isLogin();
    const isFulfillmentUser = userService.user.exerciseId != null;
    const redirect = resolveGalaxyAccess({ isLogin, isFulfillmentUser });
    if (redirect) return navigateTo(redirect);
  }
});
